import { render, staticRenderFns } from "./historyEditionList.vue?vue&type=template&id=931d7cb4&scoped=true"
import script from "./historyEditionList.vue?vue&type=script&lang=js"
export * from "./historyEditionList.vue?vue&type=script&lang=js"
import style0 from "./historyEditionList.vue?vue&type=style&index=0&id=931d7cb4&prod&lang=css"
import style1 from "./historyEditionList.vue?vue&type=style&index=1&id=931d7cb4&prod&lang=css"
import style2 from "./historyEditionList.vue?vue&type=style&index=2&id=931d7cb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931d7cb4",
  null
  
)

export default component.exports